import type { BoxProps} from '@chakra-ui/react'
import { Box, Spinner } from '@chakra-ui/react'
import { createContext, useState } from 'react'

interface LoadingOverlayProps extends BoxProps {
  children: React.ReactNode
  isLoading?: boolean
}

export interface ILoadingOverlayContext {
  loading: boolean,
  setLoading: (loading: boolean) => void
}

export const LoadingOverlayContext = createContext<ILoadingOverlayContext>({
  loading: false,
  setLoading: () => { }
})

export const LoadingOverlay = ({ children, isLoading = false, ...rest }: LoadingOverlayProps) => {
  const [loading, setLoading] = useState(isLoading)

  return (
    <LoadingOverlayContext.Provider value={
      {
        loading: loading,
        setLoading: setLoading
      }
    }>
      <Box sx={{ position: 'relative' }} {...rest}>
        <Box sx={{ position: 'relative' }}>{children}</Box>

        {loading && (
          <Box
            sx={{
              position: 'absolute',
              bg: 'rgba(255, 255, 255, 0.5)',
              cursor: 'progress',
              inset: 0,
              zIndex: 'docked',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <Spinner />
          </Box>
        )}
      </Box>
    </LoadingOverlayContext.Provider>
  )
}
